const defaultFeatures = globalThis?.defaultFeatures || {};
const featuresOverride = globalThis?.features || {};
const features = { ...defaultFeatures, ...featuresOverride };

export const FOUNDATION = !!features.foundation;

export default features;
